import React from 'react';
import Career from '../components/Career';

const Page = () => {
  return (
    <>
      <Career />
    </>
  );
};

export default Page;